<template>
    <span>
        <div class="vx-row ml-3 mt-8 mb-4">
            <div class="vx-col-w-full flex">
                <vs-checkbox color="primary" v-model="is_tab_expand" icon-pack="feather" icon="icon-check"
                    class="font-bold">Show tab titles</vs-checkbox>
            </div>
        </div>
        <div class="vx-row">
            <div class="w-full vx-col">
                <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs"
                    :key="isSmallerScreen" :value="active_step">

                    <vs-tab v-if="$canAny(['view-communication-subjects-setting'])" icon-pack="feather"
                        icon="icon-inbox" :label="is_expand ? 'CRM Contact - Subjects' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <customer-crm-subject-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-snapshot-vam-types-setting'])" icon-pack="feather" icon="icon-inbox"
                        :label="is_expand ? 'CRM Snapshop - VAM Types' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <customer-crm-vam-type-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-currency-setting'])" icon-pack="feather" icon="icon-toggle-left"
                        :label="is_expand ? 'Currency' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <currency-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-customer-source-setting'])" icon-pack="feather" icon="icon-inbox"
                        :label="is_expand ? 'Customer Sources' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <customer-source-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-incoterms-setting'])" icon-pack="feather" icon="icon-list"
                        :label="is_expand ? 'Incoterms' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <incoterm-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['edit-industrial-sector-setting'])" icon-pack="feather" icon="icon-briefcase"
                        :label="is_expand ? 'Industrial Sectors' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <industrial-sectors-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-user-type-setting'])" icon-pack="feather" icon="icon-inbox"
                        :label="is_expand ? 'Nimble User Types' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <customer-user-type-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-pack-size-setting'])" icon-pack="feather" icon="icon-inbox"
                        :label="is_expand ? 'Pack Sizes' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <pack-size-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-pricing-tier-setting'])" icon-pack="feather" icon="icon-dollar-sign" :label="is_expand ? 'Pre-set price tiers' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <PricingTierSettings />
                        </div>
                    </vs-tab>
                    <vs-tab icon-pack="feather" icon="icon-briefcase"
                        :label="is_expand ? 'Regions' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <regions-settings />
                        </div>
                    </vs-tab>
                    <vs-tab
                        v-if="$canAny(['view-orders-additional-costs-setting', 'view-sales-order-changes-reasons-setting'])"
                        icon-pack="feather" icon="icon-dollar-sign" :label="is_expand ? 'Small Order Surcharge' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <order-additional-cost-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-tax-codes-setting'])" icon-pack="feather" icon="icon-dollar-sign"
                        :label="is_expand ? 'Tax codes' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <tax-code-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-so-lead-time-setting', 'edit-so-lead-time-setting'])" icon-pack="feather" icon="icon-clock"
                        :label="is_expand ? 'SO Lead Time' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <so-lead-time-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-otif-target-setting', 'edit-otif-target-setting'])" icon-pack="feather" icon="icon-target"
                        :label="is_expand ? 'OTIF Targets' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <otif-target-settings />
                        </div>
                    </vs-tab>
                </vs-tabs>
            </div>
        </div>
    </span>
</template>
<script>

import IncotermSettings from '@/views/pages/settings/General/IncotermSettings'
import CurrencySettings from './General/CurrencySettings'
import TaxCodeSettings from "@/views/pages/settings/General/TaxCodeSettings";
import IndustrialSectorsSettings from "@/views/pages/settings/General/IndustrialSectorsSettings";
import RegionsSettings from "@/views/pages/settings/General/RegionsSettings";
import PackSizeSettings from "@/views/pages/settings/General/PackSizeSettings"
import CustomerSourceSettings from './General/CustomerSourceSettings.vue';
import CustomerCrmSubjectSettings from './General/CustomerCrmSubjectSettings.vue'
import CustomerCrmVamTypeSettings from './General/CustomerCrmVamTypeSettings.vue'
import CustomerUserTypeSettings from './General/CustomerUserTypeSettings.vue';
import OrderAdditionalCostSettings from './General/OrderAdditionalCostSettings.vue'
import PricingTierSettings from './General/PricingTierSettings.vue'
import SoLeadTimeSettings from './General/SoLeadTimeSettings.vue'
import OtifTargetSettings from './General/OtifTargetSettings.vue'


export default {
    name: 'CustomerTradingSettings',
    data() {
        return {
            is_expand: true,
            tab_mapping: {
                'crm_contact_subjects': 0,
                'crm_snapshot_vam_types': 1,
                'currency': 2,
                'customer_sources': 3,
                'incoterms': 4,
                'industrial_sectors': 5,
                'customer_user_roles': 6,
                'pack_sizes': 7,
                'order_addtional_cost': 8,
                'regions': 9,
                'tax_codes': 10,
                'bank_accounts': 11,
                'so_lead_time': 12,
                'otif_targets': 13,
                'otif_target': 13
            }
        }
    },
    components: {
        IncotermSettings,
        CurrencySettings,
        TaxCodeSettings,
        IndustrialSectorsSettings,
        RegionsSettings,
        PackSizeSettings,
        CustomerSourceSettings,
        CustomerCrmSubjectSettings,
        CustomerCrmVamTypeSettings,
        CustomerUserTypeSettings,
        OrderAdditionalCostSettings,
        PricingTierSettings,
        SoLeadTimeSettings,
        OtifTargetSettings,
    },
    computed: {
        isSmallerScreen() {
            return this.$store.state.windowWidth < 768
        },
        is_tab_expand: {
            get() { return this.is_expand },
            set(val) { this.is_expand = val }
        },
        active_step() {
            const tabParam = this.$route.query.tab;
            if (!tabParam) return 0;
            const tabValues = tabParam.split(' ');
            for (const tab of tabValues) {
                if (this.tab_mapping[tab]) {
                    return this.tab_mapping[tab];
                }
            }
            return 0;
        }
    },
}
</script>
<style lang="">

</style>